<template>
	<div class="page">
		<div title="talentTemplate" is='headered'></div>
		<div class="public_title">
			<div>成年阶段——</div>
			<div>"全球通"国际项目经理IPMP证书认证</div>
		</div>
		<div class="adult_text">国际项目管理协会IPMA（www.ipma.ch）从60年代起在全球70+国家推行项目经理IPMP认证，ABCD四级。 目前中国获 IPMP证书的人员超过了15万人。实现了与工程硕士MEM教育结合。教育部批准全国近200所高校开办了项目管理工程硕士专业，硕士毕业的学生科直接获IPMP-D级证书</div>
		<div class="adult_text">IPMP证书得到了建筑、国际工程、石油石化、铁路、电力、国防、航空、IT等10多个行业的认可，12家行业协会已将IPMP列为岗位职业管理项目经 理必备条件之一，实现了作为高技能人才的岗位津贴补助。</div>
		<div style="margin-bottom: 60px;" class="adult_text">公司2013年起与中工国际、中交集团、中国对外承包工程商会等国际工程企业，航天科工集团二院、三院，航天科技集团一院、四院、北方兵器集团、导弹院等军工企业，首信集团等国企合作，完成IPMP认证培训3000人次，90%以上获证。</div>
		
		<div style="margin-bottom: 60px;" class="adult_main dfb">
			<div>
				<div class="adult_title">IPMP -A级(Level A)  国际特级项目经理</div>
				<div class="adult_text2">国内有超过100+人获A级，有能力指导包括诸多项目的复杂规划。 </div>
				<div class="adult_text2">有能力管理组织所有项目或国际合作项目。 </div>
				<div class="adult_title">IPMP -B级(Level B)  国际高级项目经理</div>
				<div class="adult_text2">可以管理大型复杂项目、国际合作项目。 国内有超过6000+获B级。</div>
				<div class="adult_title">IPMP -C级(Level C)  国际项目经理</div>
				<div class="adult_text2">能够管理复杂项目。国内有超过150000+人获C级。</div>
				<div class="adult_title">IPMP -D级(Level D)  助理项目经理</div>
				<div class="adult_text2">具有基本知识，适合硕士、本科等学生认证助于求职。</div>				
			</div>
			<img style="width: 550px;" src="../../assets/stageImg/stage5_3.jpg" />
		</div>


		<div class="adult_imgRow">
			<img src="../../assets/stageImg/stage5_1.png" />
			<img src="../../assets/stageImg/stage5_2.png" />
		</div> 
		<div class="adult_main">
			<div class="adult_title">认证组织：</div>
			<div class="adult_text2">国际项目管理协会IPMA</div>
			<div class="adult_text2">中国（双法）项目管理研究委员会PMRC</div>
			<div class="adult_text2">PMRC指定的国内高校及协会公司认证中心</div>
			<div class="adult_title">认证形式：</div>
			<div class="adult_text2">IPMP-A/B级，考试= 项目报告 + 面试</div>
			<div class="adult_text2">IPMP-C级， 考试= 笔试 + 案例演练 + 面试</div>
			<div class="adult_text2">IPMP-D级， 考试= 笔试 </div>
			<div class="adult_title">考试时间：</div>
			<div class="adult_text2">全国统一笔试3小时，</div>
			<div class="adult_text2"> 每单月（1、3、5、7、9、11月）第三周末。 </div>
			<div class="adult_title">证书：</div>
			<div class="adult_text2">通过认证考试的学员可获得全球通行并与美国、英国、法国、瑞士、澳大利亚、日本等IPMA成员国协会互认的IPMP项目经理证书。 可以在国际项目管理协会网站 www.ipma.world 或中国官方机构www.ipmp.net.cn 上进行有效性查询。</div>
		</div>
		<div style="margin-bottom: 120px;" class="adult_imgRow">
			<img src="../../assets/stageImg/stage5_4.jpg" />
			<img src="../../assets/stageImg/stage5_5.jpg" />
		</div>
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {}
		}
	}
</script>

<style scoped="scoped">
	.public_title {
		width: 1200px;
		margin: 0 auto;
		margin-top: 90px;
		margin-bottom: 60px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}
	
	.public_title div {
		line-height: 48px;
		color: #1F2329;
		font-size: 36px;
		text-align: left;
		font-weight: bold;
	}
	
	.public_title div:nth-child(2) {
		color: #0080FF;
	}
	
	.adult_text {
		width: 1200px;
		margin: 0 auto;
		line-height: 30px;
		font-size: 18px;
		text-align: left;
		color: #51565D;
		text-indent: 2em;
	}
	
	.adult_main {
		width: 1200px;
		margin: 0 auto;
		text-align: left;
	}
	
	
	.adult_title {
		line-height: 24px;
		font-size: 20px;
		color: #0080FF;
		font-weight: 560;
		margin-bottom: 10px;
	}
	
	.adult_text2 {
		line-height: 24px;
		font-size: 18px;
		color: #51565D;
		margin-bottom: 20px;
		text-indent: 2em;
	}
	
	.adult_imgRow {
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 60px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	
	.adult_imgRow img {
		width: 588px;
	}
	
	.topImg {
		width: 1000px;
		margin: 0 auto;
		margin-bottom: 60px;
	}
</style>


// WEBPACK FOOTER //
// src/views/phaseList/adultStage.vue